(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-qty').forEach(function (q) {
      var input = q.querySelector('[data-cart-qty]');
      var form = q.closest('form');
      var submitting = false;
      function bump(n) {
        if (submitting) return;                       /* one full-page POST per interaction */
        var cur = parseInt(input.value, 10) || 0;
        var v = Math.max(0, cur + n);
        if (v === cur) return;                        /* "−" at 0 is a no-op, not a reload */
        input.value = v;
        if (form && form.requestSubmit) {
          submitting = true;
          /* Reuse one hidden input — appending per click posted update=&update=. */
          var u = form.querySelector('input[type="hidden"][name="update"]');
          if (!u) {
            u = document.createElement('input');
            u.type = 'hidden'; u.name = 'update'; u.value = '';
            form.appendChild(u);
          }
          form.requestSubmit();
        } else if (form) { submitting = true; form.submit(); }
      }
      var up = q.querySelector('[data-cart-up]');
      var down = q.querySelector('[data-cart-down]');
      if (up) up.addEventListener('click', function () { bump(1); });
      if (down) down.addEventListener('click', function () { bump(-1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hf]').forEach(function (list) {
      var items = list.querySelectorAll('[data-hf-item]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-halo-header]').forEach(function (root) {
      var drawer = root.querySelector('[data-drawer]');
      var openBtn = root.querySelector('[data-menu-open]');
      var hd = root.querySelector('[data-hd]');

      if (drawer && openBtn) {
        function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); openBtn.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; }
        function close() { drawer.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 480); }
        openBtn.addEventListener('click', open);
        root.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
        drawer.querySelectorAll('.hdr-drawer__link').forEach(function (a) { a.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
      }

      if (hd) {
        var onScroll = function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); };
        onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
      }

      /* Product hero: keep the header transparent (icons only) while the hero is on screen */
      var overlay = root.querySelector('[data-hd-overlay]');
      if (overlay) {
        var heroEl = document.querySelector('[data-px], [data-hx]');
        if (heroEl && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { overlay.classList.toggle('hd--over-hero', e.isIntersecting); });
          }, { threshold: 0 }).observe(heroEl);
        } else { overlay.classList.remove('hd--over-hero'); }
      }

      var track = root.querySelector('[data-ha-track]');
      if (track) {
        var items = track.querySelectorAll('.ha__item');
        if (items.length) {
          var i = 0; items[0].classList.add('is-on');
          if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            /* Cleared on section:unload — the theme editor re-renders the header
               on every edit, and an uncleared timer keeps ticking on detached nodes. */
            var haTimer = setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4000);
            document.addEventListener('shopify:section:unload', function (e) {
              if (e.target && e.target.contains && e.target.contains(track)) clearInterval(haTimer);
            });
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pf-group]').forEach(function (group) {
      var items = group.querySelectorAll('[data-pf-item]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-menopause"]) return;
  try {
    
  (function () {
    /* Hero — conversion carousel: direction-aware focus-pull between plates (the CSS
       does the motion; JS only says which way we're travelling and which plate is
       leaving), typed captions, progress dots, swipe, gentle auto-advance. */
    (function () {
      var root = document.querySelector('[data-px]');
      if (!root) return;
      var car = root.querySelector('[data-px-car]');
      var slides = root.querySelectorAll('[data-px-slide]');
      var dots = root.querySelectorAll('[data-px-dot]');
      if (!car || slides.length < 2) return;
      var n = slides.length, cur = 0, timer = null;
      /* Plates 2..n ship as data-src (stacked under plate 1, so loading=lazy would still
         fetch them up front and compete with the LCP plate). Hydrate once the page is
         idle, or the moment the shopper interacts — always before the first rotation. */
      var hydrated = false;
      function hydrate() {
        if (hydrated) return; hydrated = true;
        root.querySelectorAll('[data-px-slide] img[data-src]').forEach(function (im) {
          if (im.dataset.srcset) im.srcset = im.dataset.srcset;
          im.src = im.dataset.src;
          im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
        });
      }
      function hydrateSoon() { if ('requestIdleCallback' in window) requestIdleCallback(hydrate, { timeout: 2500 }); else setTimeout(hydrate, 1200); }
      if (document.readyState === 'complete') hydrateSoon(); else window.addEventListener('load', hydrateSoon);
      car.addEventListener('pointerdown', hydrate, { passive: true });
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var DUR = 5200;
      if (still) root.classList.add('px--still');
      function go(i, user, dir) {
        hydrate();
        var to = (i % n + n) % n;
        if (to === cur) { if (user) restart(); return; }
        car.setAttribute('data-dir', dir || (to > cur ? 'next' : 'prev'));
        var was = cur;
        cur = to;
        for (var k = 0; k < n; k++) {
          slides[k].classList.toggle('is-on', k === cur);
          slides[k].classList.toggle('is-out', k === was); /* the plate that recedes */
          if (dots[k]) {
            dots[k].classList.remove('is-on');
            if (k === cur) { void dots[k].offsetWidth; dots[k].classList.add('is-on'); } /* restart the progress fill */
          }
        }
        if (user) restart();
      }
      function tick() { go(cur + 1, false, 'next'); }
      function start() { if (still || timer) return; timer = setInterval(tick, DUR); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }
      for (var d = 0; d < dots.length; d++) (function (i) { dots[i].addEventListener('click', function () { go(i, true); }); })(d);
      var pv = root.querySelector('[data-px-prev]'), nx = root.querySelector('[data-px-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1, true, 'prev'); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1, true, 'next'); });
      car.addEventListener('mouseenter', function () { root.classList.add('px--paused'); stop(); });
      car.addEventListener('mouseleave', function () { root.classList.remove('px--paused'); start(); });
      var tx = 0, ty = 0;
      car.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; stop(); }, { passive: true });
      car.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1), true, dx < 0 ? 'next' : 'prev');
        else start();
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
      start();
    })();

    /* Sticky buy bar: appears once the hero panel's ATC scrolls out of view, stows when it's back. */
    (function () {
      var bar = document.querySelector('[data-bb]');
      var atc = document.querySelector('[data-px-atc]');
      if (!bar || !atc) return;
      if (!('IntersectionObserver' in window)) { bar.classList.remove('is-stowed'); return; }
      /* Direction-aware: the bar appears ONLY once the hero ATC has scrolled past the
         TOP of the viewport. The old toggle fired on any non-intersection, so an ATC
         sitting low in the first viewport (every phone) showed the bar on load,
         stacked over the real button. */
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-stowed', !passed);
        });
      }).observe(atc);
    })();

    /* Details — teardown ping-pong loop: lazy-load + play only while on screen */
    (function () {
      var v = document.querySelector('[data-sp-loop]');
      if (!v) return;
      function start() { if (!v.src) v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { v.pause(); } });
      }, { rootMargin: '250px 0px', threshold: 0.1 });
      io.observe(v);
    })();

    /* Horizontal rails (before/after, reviews, science) */
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector('.rail__card');
        var w = card ? card.getBoundingClientRect().width + 18 : 320;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var p = rail.querySelector('[data-rail-prev]'), n = rail.querySelector('[data-rail-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });

    /* Variant switch — update canonical add-to-cart + visible price */
    var vbtns = document.querySelectorAll('[data-rp-variant]');
    if (vbtns.length) {
      var priceEl = document.querySelector('[data-rp-price]');
      vbtns.forEach(function (vb) {
        vb.addEventListener('click', function () {
          vbtns.forEach(function (o) { o.classList.remove('is-on'); });
          vb.classList.add('is-on');
          var canon = document.querySelector('[data-atc-add]');
          if (canon) { canon.setAttribute('data-vid', vb.getAttribute('data-vid')); }
          var pr = vb.getAttribute('data-price');
          if (priceEl && pr) priceEl.textContent = pr;
        });
      });
    }

    /* FAQ — one open at a time */
    var fq = document.querySelector('[data-fq]');
    if (fq) {
      var items = Array.prototype.slice.call(fq.querySelectorAll('.fq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (o) { if (o !== item) o.open = false; });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-wellness"]) return;
  try {
    
  (function () {
    /* Hero — conversion carousel: direction-aware focus-pull between plates (the CSS
       does the motion; JS only says which way we're travelling and which plate is
       leaving), typed captions, progress dots, swipe, gentle auto-advance. */
    (function () {
      var root = document.querySelector('[data-px]');
      if (!root) return;
      var car = root.querySelector('[data-px-car]');
      var slides = root.querySelectorAll('[data-px-slide]');
      var dots = root.querySelectorAll('[data-px-dot]');
      if (!car || slides.length < 2) return;
      var n = slides.length, cur = 0, timer = null;
      /* Plates 2..n ship as data-src (stacked under plate 1, so loading=lazy would still
         fetch them up front and compete with the LCP plate). Hydrate once the page is
         idle, or the moment the shopper interacts — always before the first rotation. */
      var hydrated = false;
      function hydrate() {
        if (hydrated) return; hydrated = true;
        root.querySelectorAll('[data-px-slide] img[data-src]').forEach(function (im) {
          if (im.dataset.srcset) im.srcset = im.dataset.srcset;
          im.src = im.dataset.src;
          im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
        });
      }
      function hydrateSoon() { if ('requestIdleCallback' in window) requestIdleCallback(hydrate, { timeout: 2500 }); else setTimeout(hydrate, 1200); }
      if (document.readyState === 'complete') hydrateSoon(); else window.addEventListener('load', hydrateSoon);
      car.addEventListener('pointerdown', hydrate, { passive: true });
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var DUR = 5200;
      if (still) root.classList.add('px--still');
      function go(i, user, dir) {
        hydrate();
        var to = (i % n + n) % n;
        if (to === cur) { if (user) restart(); return; }
        car.setAttribute('data-dir', dir || (to > cur ? 'next' : 'prev'));
        var was = cur;
        cur = to;
        for (var k = 0; k < n; k++) {
          slides[k].classList.toggle('is-on', k === cur);
          slides[k].classList.toggle('is-out', k === was); /* the plate that recedes */
          if (dots[k]) {
            dots[k].classList.remove('is-on');
            if (k === cur) { void dots[k].offsetWidth; dots[k].classList.add('is-on'); } /* restart the progress fill */
          }
        }
        if (user) restart();
      }
      function tick() { go(cur + 1, false, 'next'); }
      function start() { if (still || timer) return; timer = setInterval(tick, DUR); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }
      for (var d = 0; d < dots.length; d++) (function (i) { dots[i].addEventListener('click', function () { go(i, true); }); })(d);
      var pv = root.querySelector('[data-px-prev]'), nx = root.querySelector('[data-px-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1, true, 'prev'); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1, true, 'next'); });
      car.addEventListener('mouseenter', function () { root.classList.add('px--paused'); stop(); });
      car.addEventListener('mouseleave', function () { root.classList.remove('px--paused'); start(); });
      var tx = 0, ty = 0;
      car.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; stop(); }, { passive: true });
      car.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1), true, dx < 0 ? 'next' : 'prev');
        else start();
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
      start();
    })();

    /* Sticky buy bar: appears once the hero panel's ATC scrolls out of view, stows when it's back. */
    (function () {
      var bar = document.querySelector('[data-bb]');
      var atc = document.querySelector('[data-px-atc]');
      if (!bar || !atc) return;
      if (!('IntersectionObserver' in window)) { bar.classList.remove('is-stowed'); return; }
      /* Direction-aware: the bar appears ONLY once the hero ATC has scrolled past the
         TOP of the viewport. The old toggle fired on any non-intersection, so an ATC
         sitting low in the first viewport (every phone) showed the bar on load,
         stacked over the real button. */
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-stowed', !passed);
        });
      }).observe(atc);
    })();

    /* Details — teardown ping-pong loop: lazy-load + play only while on screen */
    (function () {
      var v = document.querySelector('[data-sp-loop]');
      if (!v) return;
      function start() { if (!v.src) v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { v.pause(); } });
      }, { rootMargin: '250px 0px', threshold: 0.1 });
      io.observe(v);
    })();

    /* Horizontal rails (before/after, reviews, science) */
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector('.rail__card');
        var w = card ? card.getBoundingClientRect().width + 18 : 320;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var p = rail.querySelector('[data-rail-prev]'), n = rail.querySelector('[data-rail-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });

    /* Variant switch — update canonical add-to-cart + visible price */
    var vbtns = document.querySelectorAll('[data-rp-variant]');
    if (vbtns.length) {
      var priceEl = document.querySelector('[data-rp-price]');
      vbtns.forEach(function (vb) {
        vb.addEventListener('click', function () {
          vbtns.forEach(function (o) { o.classList.remove('is-on'); });
          vb.classList.add('is-on');
          var canon = document.querySelector('[data-atc-add]');
          if (canon) { canon.setAttribute('data-vid', vb.getAttribute('data-vid')); }
          var pr = vb.getAttribute('data-price');
          if (priceEl && pr) priceEl.textContent = pr;
        });
      });
    }

    /* FAQ — one open at a time */
    var fq = document.querySelector('[data-fq]');
    if (fq) {
      var items = Array.prototype.slice.call(fq.querySelectorAll('.fq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (o) { if (o !== item) o.open = false; });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    /* Hero — conversion carousel: direction-aware focus-pull between plates (the CSS
       does the motion; JS only says which way we're travelling and which plate is
       leaving), typed captions, progress dots, swipe, gentle auto-advance. */
    (function () {
      var root = document.querySelector('[data-px]');
      if (!root) return;
      var car = root.querySelector('[data-px-car]');
      var slides = root.querySelectorAll('[data-px-slide]');
      var dots = root.querySelectorAll('[data-px-dot]');
      if (!car || slides.length < 2) return;
      var n = slides.length, cur = 0, timer = null;
      /* Plates 2..n ship as data-src (stacked under plate 1, so loading=lazy would still
         fetch them up front and compete with the LCP plate). Hydrate once the page is
         idle, or the moment the shopper interacts — always before the first rotation. */
      var hydrated = false;
      function hydrate() {
        if (hydrated) return; hydrated = true;
        root.querySelectorAll('[data-px-slide] img[data-src]').forEach(function (im) {
          if (im.dataset.srcset) im.srcset = im.dataset.srcset;
          im.src = im.dataset.src;
          im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
        });
      }
      function hydrateSoon() { if ('requestIdleCallback' in window) requestIdleCallback(hydrate, { timeout: 2500 }); else setTimeout(hydrate, 1200); }
      if (document.readyState === 'complete') hydrateSoon(); else window.addEventListener('load', hydrateSoon);
      car.addEventListener('pointerdown', hydrate, { passive: true });
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var DUR = 5200;
      if (still) root.classList.add('px--still');
      function go(i, user, dir) {
        hydrate();
        var to = (i % n + n) % n;
        if (to === cur) { if (user) restart(); return; }
        car.setAttribute('data-dir', dir || (to > cur ? 'next' : 'prev'));
        var was = cur;
        cur = to;
        for (var k = 0; k < n; k++) {
          slides[k].classList.toggle('is-on', k === cur);
          slides[k].classList.toggle('is-out', k === was); /* the plate that recedes */
          if (dots[k]) {
            dots[k].classList.remove('is-on');
            if (k === cur) { void dots[k].offsetWidth; dots[k].classList.add('is-on'); } /* restart the progress fill */
          }
        }
        if (user) restart();
      }
      function tick() { go(cur + 1, false, 'next'); }
      function start() { if (still || timer) return; timer = setInterval(tick, DUR); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }
      for (var d = 0; d < dots.length; d++) (function (i) { dots[i].addEventListener('click', function () { go(i, true); }); })(d);
      var pv = root.querySelector('[data-px-prev]'), nx = root.querySelector('[data-px-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1, true, 'prev'); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1, true, 'next'); });
      car.addEventListener('mouseenter', function () { root.classList.add('px--paused'); stop(); });
      car.addEventListener('mouseleave', function () { root.classList.remove('px--paused'); start(); });
      var tx = 0, ty = 0;
      car.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; stop(); }, { passive: true });
      car.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1), true, dx < 0 ? 'next' : 'prev');
        else start();
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
      start();
    })();

    /* Sticky buy bar: appears once the hero panel's ATC scrolls out of view, stows when it's back. */
    (function () {
      var bar = document.querySelector('[data-bb]');
      var atc = document.querySelector('[data-px-atc]');
      if (!bar || !atc) return;
      if (!('IntersectionObserver' in window)) { bar.classList.remove('is-stowed'); return; }
      /* Direction-aware: the bar appears ONLY once the hero ATC has scrolled past the
         TOP of the viewport. The old toggle fired on any non-intersection, so an ATC
         sitting low in the first viewport (every phone) showed the bar on load,
         stacked over the real button. */
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-stowed', !passed);
        });
      }).observe(atc);
    })();

    /* Details — teardown ping-pong loop: lazy-load + play only while on screen */
    (function () {
      var v = document.querySelector('[data-sp-loop]');
      if (!v) return;
      function start() { if (!v.src) v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { v.pause(); } });
      }, { rootMargin: '250px 0px', threshold: 0.1 });
      io.observe(v);
    })();

    /* Horizontal rails (before/after, reviews, science) */
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector('.rail__card');
        var w = card ? card.getBoundingClientRect().width + 18 : 320;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var p = rail.querySelector('[data-rail-prev]'), n = rail.querySelector('[data-rail-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });

    /* Variant switch — update canonical add-to-cart + visible price */
    var vbtns = document.querySelectorAll('[data-rp-variant]');
    if (vbtns.length) {
      var priceEl = document.querySelector('[data-rp-price]');
      vbtns.forEach(function (vb) {
        vb.addEventListener('click', function () {
          vbtns.forEach(function (o) { o.classList.remove('is-on'); });
          vb.classList.add('is-on');
          var canon = document.querySelector('[data-atc-add]');
          if (canon) { canon.setAttribute('data-vid', vb.getAttribute('data-vid')); }
          var pr = vb.getAttribute('data-price');
          if (priceEl && pr) priceEl.textContent = pr;
        });
      });
    }

    /* FAQ — one open at a time */
    var fq = document.querySelector('[data-fq]');
    if (fq) {
      var items = Array.prototype.slice.call(fq.querySelectorAll('.fq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (o) { if (o !== item) o.open = false; });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
